import { ReportType } from "../typings/global";
import util from "../utils/util";

export default class Logger {
  metricName: string;
  dimInfo: any;
  fieldInfo: any;
  extDesc: string;
  createAt: number;

  constructor(data: ReportType.LogInfo) {
    this.addData(data);
    this.createAt = Math.round(Date.now() / 1000);
  }

  addData(data: ReportType.LogInfo) {
    const { metricName, dim, field, extdesc } = data || {};
    this.metricName = metricName || this.metricName || "";
    this.extDesc = extdesc || this.extDesc || "";
    this.dimInfo = Object.assign(this.dimInfo || {}, dim || {});
    this.fieldInfo = Object.assign(this.fieldInfo || {}, field || {});
  }

  prefixDim(data: Object) {
    if (!data) return;
    util.reAssign(this.dimInfo, data);
  }

  prefixField(data: Object) {
    if (!data) return;
    util.reAssign(this.fieldInfo, data);
  }

  toJSON() {
    return {
      name: this.metricName,
      its: this.createAt,
      dim: this.dimInfo,
      field: this.fieldInfo,
      exlog: {
        extdesc: this.extDesc,
      },
    };
  }
}
